import React from 'react';
import BackIcon from '../assets/svg/BackIcon';
import BellIcon from '../assets/svg/BellIcon';
import AlertsHeading from './AlertsHeading';

type Props = {
  onClickManage: () => void,
  isTriggers: boolean,
  goBack: () => void
};

const AlertsHead = function AlertsHead(props: Props) {
  const {
    onClickManage, isTriggers, goBack,
  } = props;
  return (
    <div className="alerts-head">
      <div className="bell-area">
        {isTriggers ? (
          <span
            className="c-pointer"
            onClick={goBack}
            onKeyPress={goBack}
            role="button"
            tabIndex={0}
            aria-label="Back Icon"
          >
            <BackIcon />
          </span>
        ) : <BellIcon />}

        <AlertsHeading heading={isTriggers ? 'Alert Filters' : 'Alerts'} />
      </div>
      <div className="manage-area">
        {
          isTriggers ? null : <span className="manage-action" onClick={onClickManage} onKeyPress={onClickManage} tabIndex={0} role="button" aria-label="alerts">Manage alerts</span>
        }
      </div>
    </div>
  );
};

export default AlertsHead;
